import { render } from "./RelatorioIndicadoresInjecaoDashboard.vue?vue&type=template&id=7be1a9f2&scoped=true"
import script from "./RelatorioIndicadoresInjecaoDashboard.vue?vue&type=script&lang=js"
export * from "./RelatorioIndicadoresInjecaoDashboard.vue?vue&type=script&lang=js"

import "./RelatorioIndicadoresInjecaoDashboard.vue?vue&type=style&index=0&id=7be1a9f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be1a9f2"]])

export default __exports__